import { message, notification } from 'antd';
import { CheckCircleTwoTone } from '@ant-design/icons';
import React from 'react';
export default {
    notifySuccess: (content = 'Thành công!', key = null) => {
        message.success({ content, key, duration: 2 });
    },
    notifyError: (content = 'Thất bại!', key = null) => {
        message.error({ content, key, duration: 3 });
    },
    notifyWarning: (content, key = null) => {
        message.warning({ content, key, duration: 2 });
    },
    notifyInfo: (content, key = null) => {
        message.info({ content, key, duration: 2 });
    },
    notifyLoading: (content = 'Đang xử lý..', key = null) => {
        message.loading({ content, key, duration: 60 });
    },
    notifyDestroy: () => {
        message.destroy();
    },
    notifyBoxInfo: (title, content, key, options = {}) => {
        notification.info({
            message: title,
            key,
            description: content,
            ...options
        });
    },
    notifyDownloadBox: (url) => {
        if (url != undefined) {
            const link = document.createElement('a');
            link.href = url;

            document.body.appendChild(link);
            link.click();

            document.body.removeChild(link);
            message.success('Tải file thành công')
        }


        // notification.info({
        //     icon:<DownloadOutlined />,
        //     message: 'Bấm vào liên kết phía dưới để tải về',
        //     description: <a 
        //         href={url} 
        //         download 
        //         rel="noopener noreferrer" 
        //         target="_blank" >{(url || '').slice(0,30)}...
        //     </a>,
        //     duration:5,
        //     placement:'bottomRight'
        // });
    }
};